/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { OrganisationIndexQueryParams, OrganisationIndexResponse } from '../types/OrganisationIndex'

/**
 * GET /organisations
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::index
 */
export async function organisationIndex(
	params?: OrganisationIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationIndexResponse>> {
	return axiosInstance.get('/organisations', { params, ...config })
}
